<template>
  <div>
    <h3>CSR Project Filter</h3>
    <div class="h4 py-5">呈現於CSR Page分頁Tab標題</div>
    <div class="form-item pa-5 h4" v-for="(item, i) in csr.tabs" :key="i">{{ item.title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    csr: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
